// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_ZckWM {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px;
	background-color: var(--f5-background);
	min-height: 100vh;
}

.meetingImage_MPGVi {
	width: 100%;
	margin-top: -250px;
	max-width: 250px;
	height: auto;
	margin-bottom: 20px;
}

.heading_vBlfC {
	font-size: 24px;
	font-weight: 600;
	color: #333;
	margin-bottom: 20px;
	text-align: center;
}

.buttonContainer_Zs85a {
	display: flex;
	gap: 15px;
}

.acceptButton_VHW1o,
.cancelButton_TPRIJ {
	padding: 12px 25px;
	font-size: 16px;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.acceptButton_VHW1o {
	background-color: var(--_16c098-color);
	color: white;
}

.cancelButton_TPRIJ {
	background-color: #f44336;
	color: white;
}

.acceptButton_VHW1o:hover {
	background-color: var(--e6fff9-background);
}

.cancelButton_TPRIJ:hover {
	background-color: #e53935;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/AcceptEvent.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,sCAAsC;CACtC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;;CAEC,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;CACtC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px;\n\tbackground-color: var(--f5-background);\n\tmin-height: 100vh;\n}\n\n.meetingImage {\n\twidth: 100%;\n\tmargin-top: -250px;\n\tmax-width: 250px;\n\theight: auto;\n\tmargin-bottom: 20px;\n}\n\n.heading {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tcolor: #333;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.buttonContainer {\n\tdisplay: flex;\n\tgap: 15px;\n}\n\n.acceptButton,\n.cancelButton {\n\tpadding: 12px 25px;\n\tfont-size: 16px;\n\tborder: none;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease;\n}\n\n.acceptButton {\n\tbackground-color: var(--_16c098-color);\n\tcolor: white;\n}\n\n.cancelButton {\n\tbackground-color: #f44336;\n\tcolor: white;\n}\n\n.acceptButton:hover {\n\tbackground-color: var(--e6fff9-background);\n}\n\n.cancelButton:hover {\n\tbackground-color: #e53935;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_ZckWM`,
	"meetingImage": `meetingImage_MPGVi`,
	"heading": `heading_vBlfC`,
	"buttonContainer": `buttonContainer_Zs85a`,
	"acceptButton": `acceptButton_VHW1o`,
	"cancelButton": `cancelButton_TPRIJ`
};
export default ___CSS_LOADER_EXPORT___;
